import { render, staticRenderFns } from "./Shop.vue?vue&type=template&id=066d1ffb&scoped=true"
import script from "./Shop.vue?vue&type=script&lang=js"
export * from "./Shop.vue?vue&type=script&lang=js"
import style0 from "./Shop.vue?vue&type=style&index=0&id=066d1ffb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066d1ffb",
  null
  
)

export default component.exports